__turbopack_context__.v({
  "alignCenter": "markdown-module__AciMnW__alignCenter",
  "alignLeft": "markdown-module__AciMnW__alignLeft",
  "alignRight": "markdown-module__AciMnW__alignRight",
  "balanced": "markdown-module__AciMnW__balanced",
  "blockquote": "markdown-module__AciMnW__blockquote",
  "blockquoteAuthor": "markdown-module__AciMnW__blockquoteAuthor",
  "center": "markdown-module__AciMnW__center",
  "figure": "markdown-module__AciMnW__figure",
  "figureCaption": "markdown-module__AciMnW__figureCaption",
  "flex": "markdown-module__AciMnW__flex",
  "imageRow": "markdown-module__AciMnW__imageRow",
  "indent": "markdown-module__AciMnW__indent",
  "inlineHeading": "markdown-module__AciMnW__inlineHeading",
  "margin": "markdown-module__AciMnW__margin",
  "readaloud": "markdown-module__AciMnW__readaloud",
  "sidebar": "markdown-module__AciMnW__sidebar",
  "spell": "markdown-module__AciMnW__spell",
  "statblockPiece": "markdown-module__AciMnW__statblockPiece",
  "table": "markdown-module__AciMnW__table",
  "tableCaption": "markdown-module__AciMnW__tableCaption",
  "tableFigure": "markdown-module__AciMnW__tableFigure",
  "tableFooter": "markdown-module__AciMnW__tableFooter",
  "tableGroup": "markdown-module__AciMnW__tableGroup",
  "tableScroll": "markdown-module__AciMnW__tableScroll",
  "ul": "markdown-module__AciMnW__ul",
});
